import { useMutation, useQuery } from "@tanstack/react-query";

import { client } from "./api-client";

export const useLogin = () =>
  useMutation({
    mutationFn: (data) =>
      client("auth/login", {
        data,
      }),
  });

export const useCreateUser = () =>
  useMutation({
    mutationFn: (data) =>
      client("auth/signup/v2", {
        data,
      }),
  });

export const useEditUser = () =>
  useMutation({
    mutationFn: (data) =>
      client("auth/user/edit", {
        data,
        successMessage: "User has been updated successfully",
      }),
  });
export const useVerifyUser = () =>
  useMutation({
    mutationFn: (data) =>
      client(`auth/validate/user?userName=${data.data.userName}`, {
        data: data.data,
      }),
  });

export const useVerifyEmail = () =>
  useMutation((data) =>
    client(`auth/verifyEmailOtp`, {
      data,
    }),
  );

export const useEmailExist = () =>
  useMutation((email) =>
    client("auth/isEmailExists", {
      data: { email },
    }),
  );

export const useGetOtp = () =>
  useMutation({
    mutationFn: (email) =>
      client(`auth/forgotPassword`, {
        data: { email },
      }),
  });

export const useVerifyOtp = () =>
  useMutation((data) =>
    client(`auth/verifyForgotPasswordOtp`, {
      data,
    }),
  );

export const useReSendOtp = () =>
  useMutation((email) =>
    client("auth/resendOtp", {
      data: { email },
    }),
  );

export const useResetPassword = () =>
  useMutation((password) =>
    client("auth/resetPassword", {
      data: { password },
      headers: {
        Authorization: sessionStorage.getItem("otp_token") || "",
      },
      successMessage: "Password has been updated successfully",
    }),
  );

export const useResetUserPassword = () =>
  useMutation({
    mutationFn: (email) => client(`auth/reset/password/v2/${email}`),
  });

export const useChangePassword = () =>
  useMutation({
    mutationFn: (data) =>
      client("auth/change/password", {
        data,
        successMessage: "Password has been updated successfully",
      }),
  });

export const useGetUserProfile = () =>
  useMutation({
    mutationFn: () => client(`auth/user/profile`),
  });

export const useGetUsersList = () =>
  useMutation({
    mutationFn: () => client(`auth/users/all`),
  });
export const useGetUsersListPaginated = () =>
  useMutation({
    mutationFn: (data) => client(`auth/users`, { data }),
  });

export const useGetRolesList = () =>
  useMutation({
    mutationFn: () => client(`auth/roles/list`),
  });

export const useGetRolesListQuery = () =>
  useQuery({
    queryFn: () => client(`auth/roles/list`),
    queryKey: ["rolesList"],
    retry: false,
  });

export const useGetRolesPaginated = () =>
  useMutation({
    mutationFn: (data) =>
      client(`auth/roles`, {
        data,
      }),
  });

export const useGetUsersListQuery = () =>
  useQuery({
    queryFn: () => client(`auth/users/list`),
    queryKey: ["usersList"],
    retry: false,
  });

export const useGetUserDetails = () =>
  useMutation({
    mutationFn: (id) => client(`auth/user/details/${id}`),
  });

export const useCreateRole = () =>
  useMutation({
    mutationFn: (data) =>
      client("auth/roles/create", {
        data,
        successMessage: "Role has been created successfully",
      }),
  });

export const useEditRole = () =>
  useMutation({
    mutationFn: (data) =>
      client("auth/roles/edit", {
        data,
        successMessage: "Role has been updated successfully",
      }),
  });
export const useGetRole = () =>
  useMutation({
    mutationFn: (name) => client(`auth/roles/${name}`),
  });

export const useGetProfile = () =>
  useMutation({
    mutationFn: () => client("auth/user/profile"),
  });

export const useUpdateProfile = () =>
  useMutation({
    mutationFn: (data) =>
      client("auth/update/profile", {
        data,
        method: "put",
        successMessage: "Profile has been updated successfully",
      }),
  });
export const useVerifyEmployeeId = () =>
  useMutation({
    mutationFn: (employeeId) => client(`auth/verify/employee/${employeeId}`),
  });

export const useUploadDocument = () =>
  useMutation({
    mutationFn: (data) =>
      client(`auth/upload/document`, {
        data,
        successMessage: "Document has been uploaded successfully",
        headers: { "Content-Type": "multipart/form-data" },
      }),
  });

export const useUnlockUser = () =>
  useMutation({
    mutationFn: (data) =>
      client(`/auth/unlock/account/${data.email}`, {
        successMessage: "User has been unlocked successfully",
      }),
  });

export const useExportUsers = () =>
  useMutation({
    mutationFn: (data) =>
      client(`/auth/users/export`, {
        data,
      }),
  });
